"use client";

import { useRef, useEffect, useState } from "react";

const testimonials = [
  {
    name: "Arun Kumar S.",
    initials: "AK",
    course: "MBA - Finance Management",
    university: "University of Madras",
    text: "Future Institute made my dream of getting an MBA possible while working full-time. The admission process was seamless and the support team guided me through every step. Highly recommend!",
    stars: 5,
  },
  {
    name: "Priya Menon",
    initials: "PM",
    course: "B.Com - General",
    university: "Manonmaniam Sundaranar University",
    text: "I was looking for a reliable distance education center in Trivandrum and found Future Institute. Their experience of 20+ years really shows in how professionally they handle everything.",
    stars: 5,
  },
  {
    name: "Rajesh Nair",
    initials: "RN",
    course: "M.Sc - Information Technology",
    university: "University of Madras",
    text: "The staff at Future Institute are incredibly helpful. They helped me choose the right course for my career goals and the entire admission process was completed online without any hassle.",
    stars: 5,
  },
  {
    name: "Deepa Lakshmi",
    initials: "DL",
    course: "MA - English",
    university: "University of Madras",
    text: "As a working professional, I needed flexible learning options. Future Institute connected me with University of Madras distance education and I completed my MA while continuing my job.",
    stars: 4,
  },
  {
    name: "Suresh Babu",
    initials: "SB",
    course: "BBA",
    university: "Manonmaniam Sundaranar University",
    text: "Excellent service! The team is very knowledgeable about all the courses and universities. They helped me understand the differences and choose the best program for my career.",
    stars: 5,
  },
  {
    name: "Anjali R.",
    initials: "AR",
    course: "M.Com - Commerce",
    university: "University of Madras",
    text: "I completed my M.Com through Future Institute and it was a wonderful experience. The spot admission facility saved me so much time. Thank you Future Institute!",
    stars: 5,
  },
];

export default function TestimonialSlider() {
  const sliderRef = useRef<HTMLDivElement>(null);
  const [activeDot, setActiveDot] = useState(0);
  const totalDots = Math.ceil(testimonials.length / 1);

  useEffect(() => {
    const interval = setInterval(() => {
      if (sliderRef.current) {
        const nextDot = (activeDot + 1) % totalDots;
        const cardWidth = 400;
        sliderRef.current.scrollTo({
          left: nextDot * cardWidth,
          behavior: "smooth",
        });
        setActiveDot(nextDot);
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [activeDot, totalDots]);

  const handleDotClick = (index: number) => {
    if (sliderRef.current) {
      const cardWidth = 400;
      sliderRef.current.scrollTo({
        left: index * cardWidth,
        behavior: "smooth",
      });
      setActiveDot(index);
    }
  };

  return (
    <section className="testimonials-section" id="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <div className="section-badge">⭐ Student Voices</div>
          <h2 className="section-title">
            What Our <span>Students Say</span>
          </h2>
          <p className="section-subtitle">
            Hear from students who have transformed their careers through
            distance education with Future Institute.
          </p>
        </div>

        <div className="testimonials-slider" ref={sliderRef}>
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card" id={`testimonial-${i}`}>
              <div className="testimonial-quote">&ldquo;</div>
              <p className="testimonial-text">{t.text}</p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">{t.initials}</div>
                <div className="testimonial-info">
                  <h4>{t.name}</h4>
                  <p>
                    {t.course} — {t.university}
                  </p>
                  <div className="testimonial-stars">
                    {"★".repeat(t.stars)}
                    {"☆".repeat(5 - t.stars)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="testimonial-dots">
          {Array.from({ length: totalDots }).map((_, i) => (
            <button
              key={i}
              className={`testimonial-dot ${i === activeDot ? "active" : ""}`}
              onClick={() => handleDotClick(i)}
              aria-label={`Go to testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
